import React, { useEffect, useState } from "react";
import Style from "./SidebarMenu.module.scss";
import Accardion from "./Accardion/Accardion";
import Accardion2 from "./Accardion2/Accardion2";
import Accardion3 from "./Accardion3/Accardion3";
import Accardion4 from "./Accardion/Accardion4/Accardion4";
import Accardion5 from "./Accardion/Accardion5/Accardion5";
import Accardion6 from "./Accardion/Accardion6/Accardion6";
import Accardion7 from "./Accardion7/Accardion7";
import Accardion9 from "./Accardion9/Accardion9";
import { getInfoAPI, LogoutAPI } from "../../../Api/PanelAdminServices";
import { errorToast } from "../../../Utils/Toast/Toast";
import Accardion10 from "./Accardion10/Accardion10";
import Accardion11 from "./Accardion11/Accardion11";
import Accardion12 from "./Accardion12/Accardion12";
import Accardion13 from "./Accardion13/Accardion13";
import Accardion14 from "./Acardion14/Accardion14";
const SidebarMenu = () => {
  const [info,setInfo]=useState([])

  useEffect(()=>{
    getAdminInfo()
  },[])

  const LogoutHandler = () => {
    let info = {
      logout: "",
    };
    LogoutAPI(info, (succ) => {
      if (succ.status === 1||succ.status===0) {
        localStorage.clear();
        setTimeout(() => {
          window.location.reload()
        }, 100);
      } else {
        errorToast("مشکلی پیش آمده");
      }
    });
  };

  const getAdminInfo=async()=>{ 
    getInfoAPI((succ,res)=>{
      if(succ){
        if(res.status===0 || res.status===-2){
          errorToast("مشکلی پیش آمده است")
          LogoutHandler()
        }else{
          setInfo(res.admin)
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
        LogoutHandler()
      }
    })
  }
  return (
    <div className={Style.componentHandler} >
      <div className={Style.userInfo}>
        <div className={Style.namePhone}>
          <h2 className={Style.name}>{info.first_name + ' '+ info.last_name}</h2>
          <h3 className={Style.phone}>{info.phone}</h3>
        </div>
        <div className={Style.imgHolder}>
          <img src={`Assets/Images/Profile/img.jpg`} alt="" />
        </div>
      </div>
      <div className={Style.accardion}>
        <Accardion12 dataCount={info?.withdraw_requests}/>
        <Accardion dataCount={info.orders}/>
        <Accardion13/>
        <Accardion14/>
        <Accardion2/>
        <Accardion3/>
        <Accardion4 dataCount={info.comments}/>
        <Accardion5 dataCount={info.supports}/>
        <Accardion6/>
        <Accardion7/>
        <Accardion9/>
        <Accardion10/>
        <Accardion11/>
      </div>
    </div>
  );
};

export default SidebarMenu;
